import React from "react";

function Portfolio() {
  return (
    <section>
      <div className="sekcja-portfolio">
        <h2 className="naglowek-portfolio">Moje Portfolio</h2>
        <p className="opis-portfolio">
          Cześć! Nazywam się Mikolaj, jestem uczniem 4 klasy technikum i pasjonuję się programowaniem.
          Poniżej znajdziesz link do mojego GitHuba, gdzie możesz zobaczyć moje
          projekty.
        </p>
        <div className="linki-portfolio">
          <a
            href="https://github.com/Mi1ku"
            target="_blank"
            rel="noopener noreferrer"
            className="link-github"
          >
            Zobacz moje projekty na GitHubie
          </a>
        </div>
        <h3 className="naglowek-technologie">Technologie, które znam:</h3>
        <ul className="lista-technologii">
          <li>
            <img src="https://upload.wikimedia.org/wikipedia/commons/6/61/HTML5_logo_and_wordmark.svg" alt="HTML Logo" className="tech-logo" /> HTML
          </li>
          <li>
            <img src="https://upload.wikimedia.org/wikipedia/commons/d/d5/CSS3_logo_and_wordmark.svg" alt="CSS Logo" className="tech-logo" /> CSS
          </li>
          <li>
            <img src="https://upload.wikimedia.org/wikipedia/commons/6/6a/JavaScript-logo.png" alt="JavaScript Logo" className="tech-logo" /> JavaScript
          </li>
          <li>
            <img src="https://upload.wikimedia.org/wikipedia/commons/a/a7/React-icon.svg" alt="React Logo" className="tech-logo" /> React
          </li>
          <li>
            <img src="https://upload.wikimedia.org/wikipedia/commons/d/d9/Node.js_logo.svg" alt="Node.js Logo" className="tech-logo" /> Node.js
          </li>
          <li>
            <img src="https://upload.wikimedia.org/wikipedia/commons/9/91/Octicons-mark-github.svg" alt="GitHub Logo" className="tech-logo" /> GitHub
          </li>
          <li>
            <img src="https://upload.wikimedia.org/wikipedia/commons/8/87/Sql_data_base_with_logo.png" alt="SQL Logo" className="tech-logo" /> SQL
          </li>
          <li>
            <img src="https://upload.wikimedia.org/wikipedia/commons/2/27/PHP-logo.svg" alt="PHP Logo" className="tech-logo" /> PHP
          </li>
          <li>
            <img src="https://upload.wikimedia.org/wikipedia/commons/0/0a/MySQL_textlogo.svg" alt="MySQL Logo" className="tech-logo" /> MySQL
          </li>
          <li>
            <img src="https://upload.wikimedia.org/wikipedia/commons/c/c3/Python-logo-notext.svg" alt="Python Logo" className="tech-logo" /> Python
          </li>
          <li>
            <img src="https://upload.wikimedia.org/wikipedia/commons/4/4f/Csharp_Logo.png" alt="C# Logo" className="tech-logo" /> C#
          </li>
          <li>
            <img src="https://upload.wikimedia.org/wikipedia/commons/1/18/ISO_C%2B%2B_Logo.svg" alt="C++ Logo" className="tech-logo" /> C++
          </li>
        </ul>
        <h3 className="naglowek-cele">Moje cele na przyszłość:</h3>
        <p className="opis-celow">
          Chcę rozwijać swoje umiejętności w programowaniu, nauczyć się nowych
          technologii takich jak TypeScript i Next.js oraz zdobyć doświadczenie w
          pracy nad większymi projektami.
        </p>
      </div>
    </section>
  );
}

export default Portfolio;
